import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "container-xxl flex-grow-1 container-p-y"
}
const _hoisted_5 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "User"),
    /*#__PURE__*/_createTextVNode("List ")
  ])
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 col-sm-12" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "table-responsive text-nowrap" }
const _hoisted_12 = {
  key: 1,
  class: "container-xxl flex-grow-1 container-p-y"
}
const _hoisted_13 = { class: "d-flex justify-content-between aling-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Update"),
    /*#__PURE__*/_createTextVNode("Category ")
  ])
], -1)
const _hoisted_15 = { name: "" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-8 col-sm-12" }
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\"><label class=\"col-sm-12 col-form-label\" for=\"basic-icon-default-fullname\">Category Title</label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span id=\"basic-icon-default-fullname2\" class=\"input-group-text\"><i class=\"bx bx-buildings\"></i></span><input type=\"text\" class=\"form-control\" id=\"basic-icon-default-fullname\" placeholder=\"Category title\"></div></div></div><div class=\"row mb-3\"><label class=\"col-sm-12 col-form-label\" for=\"basic-icon-default-company\">Ulr/Slug </label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span id=\"basic-icon-default-company2\" class=\"input-group-text\"><i class=\"bx bx-buildings\"></i></span><input type=\"text\" id=\"basic-icon-default-company\" class=\"form-control\" placeholder=\"Category alias.\"></div></div></div>", 2)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-3\"><label class=\"col-sm-12 col-form-label\" for=\"basic-icon-default-company\">SEO</label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span id=\"basic-icon-default-company2\" class=\"input-group-text\"><i class=\"bx bx-buildings\"></i></span><input type=\"text\" id=\"basic-icon-default-company\" class=\"form-control\" placeholder=\"Site Slogan/Description !\"></div></div></div><div class=\"row mb-3\"><label class=\"col-sm-12 form-label\" for=\"basic-icon-default-phone\">Meta Description</label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span id=\"basic-icon-default-company2\" class=\"input-group-text\"><i class=\"bx bx-buildings\"></i></span><input type=\"text\" id=\"basic-icon-default-phone\" class=\"form-control phone-mask\" placeholder=\"Site Slogan/Description !\"></div></div></div><div class=\"row mb-3\"><label class=\"col-sm-12 col-form-label\" for=\"basic-icon-default-email\">Meta Schema</label><div class=\"col-sm-12\"><div class=\"input-group input-group-merge\"><span class=\"input-group-text\"><i class=\"bx bx-envelope\"></i></span><input type=\"text\" id=\"basic-icon-default-email\" class=\"form-control\" placeholder=\"Enter Schema !\"></div></div></div>", 3)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4 col-sm-12\"><div class=\"card\"><div class=\"card-body\"><div class=\"Category-image\"><img src=\"https://www.imageeditexpert.com/uploads/images/about/about.png\" alt=\"n/a\" class=\"slider-setting-img\"></div><div class=\"mb-3\"><label for=\"formFile\" class=\"form-label\">Image Choose</label><input class=\"form-control\" type=\"file\" id=\"formFile\"></div><div class=\"mb-3\"><label for=\"defaultSelect\" class=\"form-label\">Default select</label><select id=\"defaultSelect\" class=\"form-select\"><option>Default select</option><option value=\"1\">One</option><option value=\"2\">Two</option><option value=\"3\">Three</option></select></div><div class=\"row justify-content-end\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-primary\">Send</button></div></div></div></div></div>", 1)
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<footer class=\"content-footer footer bg-footer-theme\"><div class=\"container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column\"><div class=\"mb-2 mb-md-0\"> ©  , made with ❤️ by <a href=\"https://themeselection.com\" target=\"_blank\" class=\"footer-link fw-bolder\">ThemeSelection</a></div><div><a href=\"https://themeselection.com/license/\" class=\"footer-link me-4\" target=\"_blank\">License</a><a href=\"https://themeselection.com/\" target=\"_blank\" class=\"footer-link me-4\">More Themes</a><a href=\"https://themeselection.com/demo/sneat-bootstrap-html-admin-template/documentation/\" target=\"_blank\" class=\"footer-link me-4\">Documentation</a><a href=\"https://github.com/themeselection/sneat-html-admin-template-free/issues\" target=\"_blank\" class=\"footer-link me-4\">Support</a></div></div></footer><div class=\"content-backdrop fade\"></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_List = _resolveComponent("List")!
  const _component_CkEditor = _resolveComponent("CkEditor")!
  const _component_AddForm = _resolveComponent("AddForm")!
  const _component_EditForm = _resolveComponent("EditForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDataTrue == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isupdate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.iscomponent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            class: "btn btn-primary mt-2",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateIsDataTrue && _ctx.updateIsDataTrue(...args)))
                          }, " Add Category ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_List, { onDataEmitted: _ctx.receiveData }, null, 8, ["onDataEmitted"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isupdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-primary mt-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)))
              }, " Category List ")
            ])
          ]),
          _createElementVNode("form", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_CkEditor, { value: "demo data" }),
                      _hoisted_23
                    ])
                  ])
                ])
              ]),
              _hoisted_26
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_AddForm, {
          key: 2,
          isDataTrue: _ctx.isDataTrue,
          onUpdateIsDataTrue: _ctx.updateIsDataTrue
        }, null, 8, ["isDataTrue", "onUpdateIsDataTrue"])),
    _createVNode(_component_EditForm, {
      "received-data": _ctx.receivedData|| {},
      onUpdateIsDataTrue: _ctx.handleUpdateDataEdit
    }, null, 8, ["received-data", "onUpdateIsDataTrue"]),
    _createElementVNode("p", null, "Received isDataTrueList in Parent Component: " + _toDisplayString(_ctx.receivedIsDataTrueList), 1),
    _createElementVNode("p", null, "Received id in Parent Component: " + _toDisplayString(_ctx.receivedId), 1),
    _hoisted_27
  ]))
}